// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function Link(theme) {
  return {
    MuiLink: {
      defaultProps: {
        underline: "hover",
      },
    },
  }
}
